export const staticMetaProps = (subdomain: string) => ({
  seoUrl: `https://${subdomain}.cian.ru/reyting-rieltorov/`,
  seoTitle: 'Рейтинг риэлторов, агенты по недвижимости, список специалистов недвижимости - ЦИАН',
  seoDescription: `ЦИАН - рейтинг риэлторов, агентов по продаже и аренде недвижимости, а также других специалистов недвижимости России`,
  seoKeywords: 'рейтинг, риэлтор, агент недвижимости, циан',
});
